import { DEFAULT_TEAM_NAME } from '@/common/constants';
import type { BracketCardMatch, Score } from '@/ui/components/BracketCard/BracketCard.types';
import type { KnockoutMatch } from '../types';
import formatDateLocaleDependent from './formatDateLocaleDependent';
import formatTimeLocaleDependent from './formatTimeLocaleDependent';

function getTeamName(team: string | null): string | undefined {
  if (team === null || team === DEFAULT_TEAM_NAME) {
    return undefined;
  }

  return team;
}

function getScore(homeScore: number | null, awayScore: number | null): Score | undefined {
  if (homeScore !== null && awayScore !== null) {
    return { home: homeScore, away: awayScore };
  }

  return undefined;
}

export function mapKnockoutMatchToBracketCardMatch(match: KnockoutMatch): BracketCardMatch {
  let formattedDate: string | undefined = undefined;
  let formattedTime: string | undefined = undefined;

  if (match.date) {
    formattedDate = formatDateLocaleDependent(match.date);
    formattedTime = formatTimeLocaleDependent(match.date);
  }

  return {
    formattedDate: formattedDate,
    formattedTime: formattedTime,
    homeTeamName: getTeamName(match.home_team),
    awayTeamName: getTeamName(match.away_team),
    homeImageSrc: match.home_flag ?? match.home_jersey ?? undefined,
    awayImageSrc: match.away_flag ?? match.away_jersey ?? undefined,
    previousMeetingScore: getScore(match.first_leg_home_score, match.first_leg_away_score),
    finalScore: getScore(match.home_score, match.away_score),
    penaltyScore: getScore(match.home_penalty_score, match.away_penalty_score),
    isTbdHidden: match.home_team === null || match.away_team === null,
  };
}
